import { HTTP } from '@/api/http-common'
import { HTTPMultipartFormData } from '@/api/http-multipart-form'

export default {
  getContactForm (params, callback) {
    HTTP.get(params.token + '/form/contact').then(response => {
      callback(response)
    }).catch(e => {
      console.log(e)
    })
  },
  submitContactForm (params, callback) {
    HTTPMultipartFormData.post(params.token + '/orders/contact', params.formData).then(response => {
      callback(response)
    }).catch(e => {
      console.log(e)
      if (e.response.status === 400 || e.response.status === 500) {
        callback(e.response)
      }
    })
  },
  submitShappyContactForm (params, callback) {
    HTTPMultipartFormData.post(params.token + '/shappy/orders/contact', params.formData).then(response => {
      callback(response)
    }).catch(e => {
      console.log(e)
      if (e.response.status === 400 || e.response.status === 500) {
        callback(e.response)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/contact_form/index.js